export const MAX_TAG_WIDTH = "20";
export const MAX_TAG_HEIGHT = "20";
